import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

const useSillSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);
  const sillStyle = useStore((state) => state.quote.sillStyle);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = label === sillStyle;

    if (checked) {
      addToQuote({ sillStyle: "" }, "sillStyle");
    } else {
      addToQuote({ sillStyle: label });

      if (findRequired("Sill Type")) {
        removeRequired("Sill Type");
      }
    }
  };

  const publicId = sillStyle?.includes("Aluminum") ? "clad" : "wood";

  return {
    publicId,
    handleClick,
    sillStyle
  };
};

export default useSillSelector;
